import { c as _c } from "react/compiler-runtime";
import { Form, Formik } from 'formik';
import { useContext } from 'react';
import Alert from '../../../../common/base/Alert';
import Button from '../../../../common/base/Button';
import { StyledCard } from '../../../../common/base/Card';
import Icon from '../../../../common/base/Icon';
import Text from '../../../../common/base/Text';
import TextInput from '../../../../common/Form/Fields/TextInput';
import { Div } from '../../../../common/helpers/StyledUtils';
import { useToasts } from '../../../../common/Toast';
import { GlobalContext } from '../../../../contexts/GlobalContext';
import { UserContext } from '../../../../contexts/UserContext';
const AccountAuthentication: React.FC = () => {
  const $ = _c(35);
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const {
    user,
    mutateUser
  } = useContext(UserContext);
  const {
    addToast
  } = useToasts();
  let t0;
  if ($[0] !== HookdeckAPI.session || $[1] !== addToast || $[2] !== mutateUser || $[3] !== user) {
    t0 = values => HookdeckAPI.session.updatePassword(values.new_password, user.has_password ? values.old_password : null).then(() => {
      mutateUser({
        ...user,
        has_password: true
      });
      addToast("success", "Password updated");
    }).catch(e => {
      addToast("error", `Failed to update password: ${e.response?.message}`);
    });
    $[0] = HookdeckAPI.session;
    $[1] = addToast;
    $[2] = mutateUser;
    $[3] = user;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  const handleSubmit = t0;
  if (user.sso_idp_id) {
    let t1;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Alert inline={true} info={true} m={{
        b: 10
      }}>This account is managed by your organization SSO provider. To change your password or credentials contact your administrator.</Alert>;
      $[5] = t1;
    } else {
      t1 = $[5];
    }
    return t1;
  }
  let t1;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      b: 10
    };
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Text bold={true} size="l" as="h2" m={{
      b: 4
    }}>Password</Text>;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      new_password: "",
      old_password: ""
    };
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== user.has_password) {
    t4 = values_0 => {
      const errors = {};
      if (user.has_password && (!values_0.old_password || values_0.old_password.length === 0)) {
        errors.old_password = "Required";
      }
      if (!values_0.new_password || values_0.new_password.length === 0) {
        errors.new_password = "Required";
      } else {
        if (values_0.new_password.length < 8) {
          errors.new_password = "Password must contain at least 8 characters";
        }
      }
      return errors;
    };
    $[9] = user.has_password;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== handleSubmit) {
    t5 = (values_1, t6) => {
      const {
        resetForm
      } = t6;
      return handleSubmit(values_1).then(() => {
        resetForm({});
      });
    };
    $[11] = handleSubmit;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== user.has_password) {
    t6 = props => <Form>{user.has_password && <TextInput label="Current password" name="old_password" type="password" auto_complete="current-password" required={true} />}<TextInput m={{
        b: 5
      }} label={user.has_password ? "New password" : ""} name="new_password" type="password" auto_complete="new-password" required={true} /><Button disabled={!props.isValid || !props.touched || props.isSubmitting || !props.values.new_password || !props.values.new_password} primary={true} submit={true} icon={props.isSubmitting ? "loading" : "save"}>Save</Button></Form>;
    $[13] = user.has_password;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t4 || $[16] !== t5 || $[17] !== t6) {
    t7 = <Div m={t1}>{t2}<Formik initialValues={t3} validate={t4} onSubmit={t5}>{t6}</Formik></Div>;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      b: 10
    };
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Text bold={true} size="l" as="h2" m={{
      b: 4
    }}>Linked accounts</Text>;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== user.github_id) {
    t10 = user.github_id && <StyledCard flex={{
      align: "center"
    }} m={{
      b: 4
    }} p={{
      x: 4,
      y: 3
    }}><Text flex={{
        align: "center"
      }}><Icon left={true} src="/images/github-icon.svg" />Authenticated using Github SSO</Text></StyledCard>;
    $[21] = user.github_id;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== user.google_id) {
    t11 = user.google_id && <StyledCard flex={{
      align: "center"
    }} m={{
      b: 4
    }} p={{
      x: 4,
      y: 3
    }}><Text flex={{
        align: "center"
      }}><Icon left={true} src="/images/google-icon.png" />Authenticated using Google SSO</Text></StyledCard>;
    $[23] = user.google_id;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== user.github_id || $[26] !== user.google_id) {
    t12 = !user.google_id && !user.github_id && <StyledCard p={{
      x: 4,
      y: 3
    }}><Text muted={true} center={true}>No linked accounts.</Text></StyledCard>;
    $[25] = user.github_id;
    $[26] = user.google_id;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t10 || $[29] !== t11 || $[30] !== t12) {
    t13 = <Div m={t8}>{t9}{t10}{t11}{t12}</Div>;
    $[28] = t10;
    $[29] = t11;
    $[30] = t12;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== t13 || $[33] !== t7) {
    t14 = <>{t7}{t13}</>;
    $[32] = t13;
    $[33] = t7;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  return t14;
};
export default AccountAuthentication;